export default __webpack_public_path__ + "static/media/dota2.7fee6ba8.svg";